import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
console.log(window.location.pathname);
//window.location.pathname
root.render(

  <Provider store={store}>
     <BrowserRouter basename={window.location.pathname.includes('newportal')? '/newportal' : '/'}>
      <App />
    </BrowserRouter>
  </Provider>

);


        
